<template>
  <div id="guide">
    <b-container class="bv-example-row">
      <b-row>
        <b-col></b-col>
        <b-col>
          <h3 tyle="text-align: center;">מדריך</h3>
          <p dir="rtl" style="direction: rtl; text-align: right; ">
            <b>המשחק מיועד לשני שחקנים.</b>
            <br />ראשית נפתחות 25 מילים.
            <br />כל שלב מוגבל עד 8 דקות.
            <br />יהיו 12 תורות בסה"כ למשחק (6 כל אחד).
            <br />2 השחקנים יכולים לחדש משחק במידה והמילים נראות להם חסרות קשר.
            <br />

            <b>מהלך המשחק:</b>
            <br />כל שחקן מקבל מפה בה מופיעות 8 מילים שהוא צריך להגדיר (יכולות להיות מילים ששייכות לשני השחקנים), ו-4 מילים שאסור שייבחרו (מילים שחורות).
            <br />שחקן 1 מתחיל. צריך לבחור מ1 עד 8 מילים, ולתת הגדרה ומספר. (למשל עוף-3)
            <br />מותר לתת הגדרות דומות (למשל כל שחקן יכול להשתמש במילה - עוף)
            <br />שחקן 2. מקבל את ההגדרה, ומנסה לבחור את המילים שקשורות להגדרה. בכל פעם הוא בוחר מילה אחת. במידה והיא נכונה היא מסומנת, והוא יכול להמשיך למילה הבאה עד שמצליח את כל המילים.
            <br />במידה והצליח את כולם. הוא עובר להיות במצב של בוחר הגדרה על פי המפה שלו.
            <br />גם במידה וטעה, עובר למצב של בוחר הגדרה.
            <br />
            <!-- בתור הבא יכול לנסות לנחש שוב באופן חד פעמים (לא יכול לנסות כמה תורות) את המילים הנותרות להגדרה שטעה בה. -->
            <b>המשחק נגמר כאשר:</b>
            <br />עברו 12 תורות.
            <br />במידה ונבחרה מילה שחורה של היריב.
            <br />השחקנים הצליחו את כל המילים.
            <br />
          </p>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Guide",
  data() {
    return {};
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Guide.vue